const initGDPRAppRules = () => {
  // document.addEventListener("GDPR_LC:userConsentSetting", (e) => {
  //     if (e?.detail?.type_0?.true === 1 || e?.detail?.type_1?.true === 1) {
  //       // console.log('tracking accepted, enabling legal consent in Kameleoon...');
  //       window.kameleoonQueue = window.kameleoonQueue || [];
  //       window.kameleoonQueue.push(["Kameleoon.API.Core.enableLegalConsent"]);
  //     }

  //     if (e?.detail?.type_2?.true === 1 && e?.detail?.type_0?.false === 1 || e?.detail?.type_2?.true === 1 && e?.detail?.type_1?.false === 1) {
  //       window.kameleoonQueue = window.kameleoonQueue || [];
  //       window.kameleoonQueue.push(["Kameleoon.API.Core.disableLegalConsent"]);
  //     }
  // });

  window.addEventListener('PandectesEvent_OnConsent',(e)=>{
    console.log(e.detail.preferences)
    if (e.detail.preferences === 0) {
      Kameleoon.API.Core.enableLegalConsent()
    }else {
      Kameleoon.API.Core.disableLegalConsent()
    }
  })
};

initGDPRAppRules()
